<div
    class="my-bets-bet-card-title"
    [ngClass]="{ 'my-bets-bet-card-title--with-paddings': shouldApplyPaddings(), 'pb-0': mybetsConfig.showSportAndCompetitionName }">
    @if (isOutcomeBadgeVisible()) {
        <div class="betslip-badges-container" [ngClass]="{ 'is-won': isWon() }">
            <ms-my-bets-outcome-badge [betslip]="betslip()" />
            @if (isWonWithBrandLogo()) {
                <img
                    class="brand-logo-won"
                    priority
                    [ngSrc]="brandLogoImage().src"
                    alt="{{ brandLogoImage().alt }}"
                    [width]="brandLogoImage().width"
                    [height]="brandLogoImage().height" />
                @if (backgroundImage()) {
                    <img class="background-image" fill [ngSrc]="backgroundImage().src" alt="{{ backgroundImage().alt }}" />
                }
            }
        </div>
    }
    <div class="bets-title">
        <div class="left-section" [ngClass]="{ 'my-bets-bet-card-title-combo-bet': isBetBuilder() }">
            <span class="content" [ngClass]="{ 'edit-bet-seperator': showEditBet }"><ng-content select="[title]"></ng-content></span>
            @if (showEditBet) {
                <ms-my-bets-betslip-card-title-options
                    [betslip]="betslip()"
                    [myBetsListContext]="myBetsListContext()"
                    [isBetSlipBadgeVisible]="false" />
            }
        </div>
        <div class="right-section">
            @if (showBetOdds() && bet() && bet()?.odds) {
                @if (bet()?.isBanker) {
                    <div class="banker-icon">{{ siteCore.betslip.messages.BankerAbbr }}</div>
                }
                <span class="mybets-betslip-bet-odds" odds>{{ bet()?.odds | msMyBetsOddsPipe }}</span>
            } @else if (!showBetOdds() && betslip() && betslip().totalOdds) {
                <span [ngClass]="{ 'original-odds': oddsAreBoosted || isSGPRepricedOdds }">
                    {{ totalOddsValue() }}
                </span>
                @if (oddsAreBoosted) {
                    <span>{{ boostedOdds() | msMyBetsOddsPipe }}</span>
                }
                @if (isSGPRepricedOdds) {
                    <span>{{
                        betslip().isOGPRepricePending
                            ? this.sitecoreMyBets.myBets.PendingOdds
                            : (this.betslip().totalOGPRepricedOdds | msMyBetsOddsPipe)
                    }}</span>
                }
            }
        </div>
    </div>
    <span class="sub-title"><ng-content select="[sub_title]"></ng-content></span>
</div>
